import React from "react";
import PoliciesHeader from "../Components/PoliciesHeader/PoliciesHeader";
import { useStyle } from "../Components/PoliciesWrapper/Style";
import DisplayPepPolicies from "../Components/Policies/DisplayPepPolicies";

// Standalone PEP flagged policies page, mirroring the AML policies dashboard.
// DisplayPepPolicies fetches its own data (pep_flagged=true), so no Redux
// wiring is needed here.
const PepPoliciesDashboard = () => {
  const classes = useStyle();

  return (
    <>
      <PoliciesHeader title="PEP Flagged Policies" />

      <section className={classes.claimswrapper}>
        <DisplayPepPolicies />
      </section>
    </>
  );
};

export default PepPoliciesDashboard;
